import { AppBar, Box, Button, Stack, Toolbar, Hidden, Drawer } from "@mui/material";
import Sidebar from "./Sidebar";
import FerreroLogo from "./FerreroLogo";
import { ReactNode, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";


const DRAWER_WIDTH = 240;

interface Props {
  children?: ReactNode;
}

export default function DashboardLayout({ children }: Props) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const toggleSidebar = () => {
    setSidebarOpen((isOpen) => !isOpen);
  };

  return (
    <div>
    <Box display="flex" >
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1}}
      >
        <Toolbar sx={{ position: "relative" }}>
          <Header toggleSidebar={toggleSidebar} />
        </Toolbar>
      </AppBar>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          open={sidebarOpen}
          onClose={closeSidebar}
          ModalProps={{ keepMounted: true }}
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
        >
          <Box width={DRAWER_WIDTH} maxWidth="100vw">
            <Box paddingTop={2} paddingX={2}>
              <FerreroLogo color="#795548" />
            </Box>
            <Sidebar onClose={closeSidebar} />
          </Box>
        </Drawer>
      </Hidden>
      <Toolbar></Toolbar>
    </Box>
  </div>
  );
}
